export const GET_CUSTOMER_SERVICE = "GET_CUSTOMER_SERVICE"
export const GET_CUSTOMER_SERVICE_SUCCESS = "GET_CUSTOMER_SERVICE_SUCCESS"
export const GET_CUSTOMER_SERVICE_FAIL = "GET_CUSTOMER_SERVICE_FAIL"

export const ADD_CUSTOMER_SERVICE = "ADD_CUSTOMER_SERVICE"
export const ADD_CUSTOMER_SERVICE_SUCCESS = "ADD_CUSTOMER_SERVICE_SUCCESS"
export const ADD_CUSTOMER_SERVICE_FAIL = "ADD_CUSTOMER_SERVICE_FAIL"

export const UPDATE_CUSTOMER_SERVICE = "UPDATE_CUSTOMER_SERVICE"
export const UPDATE_CUSTOMER_SERVICE_SUCCESS = "UPDATE_CUSTOMER_SERVICE_SUCCESS"
export const UPDATE_CUSTOMER_SERVICE_FAIL = "UPDATE_CUSTOMER_SERVICE_FAIL"

export const DELETE_CUSTOMER_SERVICE = "DELETE_CUSTOMER_SERVICE"
export const DELETE_CUSTOMER_SERVICE_SUCCESS = "DELETE_CUSTOMER_SERVICE_SUCCESS"
export const DELETE_CUSTOMER_SERVICE_FAIL = "DELETE_CUSTOMER_SERVICE_FAIL"

export const SHOW_LOADING = "SHOW_LOADING"
export const HIDE_LOADING = "HIDE_LOADING"
